import { CloudDownload, PictureAsPdf } from "@mui/icons-material"
import { Button, Grid } from "@mui/material"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import { useGET_resourcesQuery } from "redux/api/resourcesApi"
import { toHtml, translateGradeLevel } from "utils/helpers"

const SectionPrintables: FC<{iframe?: boolean}> = ({iframe = false}) => {
  const { t } = useTranslation()
  const { data: resources } = useGET_resourcesQuery({})

  return (
    <>
    <Grid container spacing={2}> 
    {
                resources?.results?.length > 0 && resources.results.slice(0,4).map(r => 
                      <Grid key={r.id} item xs={12} sm={4} xl={2}>
                        <div style={{
                            border: '1px solid #ccc',
                            borderRadius: '10px',
                            marginBottom: '10px',
                            background: '#fff',
                            height: '100%',
                            position: 'relative',
                            paddingBottom: '40px'
                        }}>

                            <div style={{
                                aspectRatio: 1.5,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center center',
                                backgroundColor: '#f5f5f5',
                                backgroundImage: `url('${r.image}')`,
                            }}></div>
                            <div style={{ 
                                fontSize: '18px',
                                lineHeight: '24px',
                                fontWeight: '500',
                                padding: '10px'
                            }}>
                                {r.title}     
                            </div>
                            <div style={{ 
                                padding: '10px',
                                fontSize: '12px'
                            }} dangerouslySetInnerHTML={toHtml(r.description)} />
                            <div style={{ 
                                padding: '10px',
                                fontSize: '12px'
                            }} >
                                {t('common.grade-level')}: {translateGradeLevel(r.grade_level)}

                            </div>
                            <div style={{ 
                                position: 'absolute',
                                bottom: '0px',
                                left: '0px',
                                width: '100%',
                                padding: '10px', 
                                display: 'flex', 
                                alignItems: 'center' }}>

                                {r.attachment && 
                                <Button
                                    variant='contained'
                                    color='blue'
                                    size='small'
                                    onClick={() => window.open(r.attachment, '_blank', 'rel=noopener noreferrer')}
                                    >
                                    <CloudDownload />
                                    <span
                                        style={{ fontSize: '12px', marginLeft: '5px' }}
                                    >{t('dashboard.download')}</span>
                                </Button>}

                            </div>
                        </div>
                        </Grid>
                    )
                
                }
      </Grid>
    </>
  )
}

export default SectionPrintables
